import type { MetaHTMLAttributes, LinkHTMLAttributes } from "react";
import { isServer } from "@tanstack/react-query";

export function GameMetadata({
  head,
}: {
  readonly head: {
    readonly meta: MetaHTMLAttributes<HTMLMetaElement>[];
    readonly links?: LinkHTMLAttributes<HTMLLinkElement>[];
  };
}) {
  if (isServer) return null;

  return (
    <>
      {head.meta.map((entry, index) =>
        entry.title ? (
          <title key={index}>{entry.title}</title>
        ) : (
          <meta key={index} {...entry} />
        ),
      )}
      {head.links?.map((entry, index) => (
        <link key={index} {...entry} />
      ))}
    </>
  );
}
